import type { PaymentTerminalView } from '../../../services/credit-payments/credit-payments.service';

export const FIXED_TERMINAL_STORAGE_KEY = 'posFixedTerminalId';

export type FixedTerminalTarget = {
  terminalId: number;
  pinpadId: string;
};

export function getFixedTerminalTarget(): FixedTerminalTarget | null {
  const raw = localStorage.getItem(FIXED_TERMINAL_STORAGE_KEY);
  if (!raw) return null;
  try {
    const parsed: unknown = JSON.parse(raw);
    if (
      typeof parsed === 'object'
      && parsed !== null
      && Number.isInteger((parsed as FixedTerminalTarget).terminalId)
      && typeof (parsed as FixedTerminalTarget).pinpadId === 'string'
      && (parsed as FixedTerminalTarget).pinpadId.trim().length > 0
    ) {
      return parsed as FixedTerminalTarget;
    }
  } catch {
    // A legacy terminal-only value is intentionally treated as no pin.
  }
  return null;
}

export function setFixedTerminalTarget(target: FixedTerminalTarget): void {
  localStorage.setItem(FIXED_TERMINAL_STORAGE_KEY, JSON.stringify(target));
}

export function clearFixedTerminalId(): void {
  localStorage.removeItem(FIXED_TERMINAL_STORAGE_KEY);
}

// A terminal pin is device-local; invalid/stale pins must not hide usable tenant terminals.
export function resolveFixedTerminals(
  terminals: PaymentTerminalView[],
  fixedTerminalTarget: FixedTerminalTarget | null = getFixedTerminalTarget(),
): PaymentTerminalView[] {
  if (fixedTerminalTarget == null) return terminals;
  const terminal = terminals.find((item) => item.id === fixedTerminalTarget.terminalId);
  const pinpad = terminal?.pinpads.find((item) => item.pinpadId === fixedTerminalTarget.pinpadId);
  return terminal && pinpad ? [{ ...terminal, pinpads: [pinpad] }] : terminals;
}